import set from 'lodash/set';

import { updateValidation, updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { setViewId } from './AccountsManualStepActions';

import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';

export const onCancel = (
  workflowId,
  clientId,
  account,
  graphAccounts,
  previousViewId,
) => (dispatch) => {
  if (
    account.frontEndId &&
    account.frontEndId === graphAccounts[graphAccounts.length - 1].frontEndId
  ) {
    dispatch(updateData(
      {
        [BACKEND_KEY]: graphAccounts.slice(0, graphAccounts.length - 1),
      },
      workflowId,
      clientId,
    ));
  }
  dispatch(updateValidation(set({}, `${BACKEND_KEY}.AccountAddEdit`, []), workflowId, clientId));
  dispatch(setViewId(previousViewId, workflowId, clientId));
};

export default onCancel;
